<script setup lang="ts">
import { i18n } from '@/locales/i18n'
import { computed } from 'vue'
import GwTooltipNew from '@/components/lib/GwTooltip/GwTooltipNew.vue'

interface GwStatusItemProps {
  value: string
  tstPrefix?: string
  hasTitle?: boolean
  hasTooltip?: boolean
  langPath?: string
}

const props = withDefaults(defineProps<GwStatusItemProps>(), {
  tstPrefix: 'item',
  hasTitle: true,
  langPath: 'statuses.',
})

const {
  global: { t },
} = i18n

const icons: Record<string, { icon: string; color: string }> = {
  ERROR: { icon: 'mdi-alert-circle-outline', color: 'var(--clr-error)' },
  LIMIT_REACHED: { icon: 'mdi-stop-circle-outline', color: 'var(--clr-error)' },
  IN_QUEUE: { icon: 'mdi-file-clock-outline', color: 'var(--clr-error)' },
  PARTIALLY_FINISHED: { icon: 'mdi-progress-alert', color: 'var(--clr-blue)' },
  UPLOADING: { icon: 'mdi-cloud-upload', color: 'var(--clr-blue)' },
  PROCESSING: { icon: 'mdi-autorenew', color: 'var(--clr-yellow)' },
  ANALYSING: { icon: 'mdi-autorenew', color: 'var(--clr-yellow)' },
  FINISHED: { icon: 'mdi-check', color: 'var(--clr-primary)' },
  ZERO_PERCENT_ACTION: { icon: 'mdi-alert-circle-outline', color: 'var(--clr-error)' },
  UNSUPPORTED_PLAYERS: { icon: 'mdi-alert-circle-outline', color: 'var(--clr-error)' },
  NO_GTO_SOLUTION: { icon: 'mdi-progress-alert', color: 'var(--clr-blue)' },
  STACK_NOT_SUPPORTED: { icon: 'mdi-alert-circle-outline', color: 'var(--clr-error)' },
  SPOT_NOT_SUPPORTED: { icon: 'mdi-alert-circle-outline', color: 'var(--clr-error)' },
  OK: { icon: 'mdi-check', color: 'var(--clr-primary)' },
}

export type StatusItemT = keyof typeof icons

const icon = computed(
  () =>
    icons[props.value] || {
      icon: 'mdi-questionmark',
      color: 'var(--clr-black-4)',
    },
)
</script>
<template>
  <div
    class="gw_status_item mw-0"
    :data-tst="`${tstPrefix}_statusitem_${value}`"
  >
    <GwTooltipNew
      v-if="hasTooltip"
      :tooltip="t(`${langPath}${value}`)"
      placement="right"
    >
      <template #opener="{ listeners }">
        <div
          class="mdi gw_status_item_icon"
          :class="icon.icon"
          :style="`color: ${icon.color}`"
          v-on="listeners"
        />
      </template>
    </GwTooltipNew>
    <div
      v-else
      class="mdi gw_status_item_icon"
      :class="icon.icon"
      :style="`color: ${icon.color}`"
    />

    <div
      v-if="hasTitle"
      class="truncate line-height_initial"
      :title="t(`${langPath}${value}`)"
    >
      {{ t(`${langPath}${value}`) }}
    </div>
  </div>
</template>
<style lang="scss" scoped>
.gw_status_item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  justify-self: flex-start;
  &_icon {
    font-size: 1.25em;
  }
}
</style>
